import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import NotFound from "../components/common/404";
import LandingPage from "../pages";
import OldSignUpPage from "../pages/oldsignup";
import SignUpPage from "../pages/signup";
import LoginPage from "../pages/Login";
import Membership from "../pages/membership/index";
import MemebrshipPaymentCheckoutPage from "../pages/membership/MemebrshipPaymentCheckoutPage";
import MerchantProfilePage from "../pages/merchant-membership/merchant-profile";
import MembershipUpgradePage from "../pages/merchant-membership/membership-upgrade";
import MembershipLavelPage from "../pages/merchant-membership/membership-lavel";
import BusinessModelPage from "../pages/business/business-model";
import BusinessCreatePage from "../pages/business/business-create";
import BusinessContractAddressPage from "../pages/business/business-contract-address";
import BusinessContractListPage from "../pages/business/business-contract-list";
import BusinessDayInfoPage from "../pages/business/business-day-info";
import PersonalDetailsPage from "../pages/merchant-membership/personal-details";
import ShopRequestProductAddPage from "../pages/business/my-shop-demo";
import ShopSettledOrdersPage from "../pages/shops/settlement/settledOrder";
import ShopSettledOrderDetailsPage from "../pages/shops/settlement/settledOrderDetails";

import ShopUnsettledOrdersPage from "../pages/shops/settlement/unsettledOrder";

import RequestProductAddPage from "../pages/requested-products/create";

import MyShopProductPage from "../pages/shops/products/shopProductList";
import ShopContractAddressUpdatePage from "../pages/shops/contract-address/edit";
import MyShopProductCataloguePage from "../pages/shops/products/myShopProductCatalogue";

import CampaignAssignProductPage from "../pages/promotions/campaign/assign-products";
import CampaignProductPage from "../pages/promotions/campaign/products";
import CampaignDetailsPage from "../pages/promotions/campaign/details";
import MyShopOrderDetailsPage from "../pages/shops/orders/myShopOrderDetails";

import ShopProductDetailsPage from "../pages/shops/products/details";
import ShopRequestProductDetailsPage from "../pages/requested-products/details";
import ShopRequestProductEditPage from "../pages/shops/products/request-product-edit";
import ShopCatalogProductDetailsPage from "../pages/global-product/details";
import ShopOutOfStockProductDetailsPage from "../pages/products/details";

import AddBankInfoPage from "../pages/business/bank-info";
import MarchantDashboardPage from "../pages/main-seller-dashboard";

import myshopTestBankInfoPage from "../pages/business/my-shop-demo";
import BrandAddPage from "../pages/business/brand-add";
import BankInfoPage from "../pages/administration/services";
import { adminServices, isAllowedService } from "../utils/services";
import ShopChatPage from "../pages/shops/chats";

const MainRoutes = (): any => {
  const { token } = useSelector((state) => (state as any)?.authReducer);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="signup" element={<SignUpPage />} />
        <Route path="login" element={<LoginPage />} />
        {/* <Route path="merchant-dashboard" element={<MarchantDashboardPage />} /> */}
        <Route path="oldsignup" element={<OldSignUpPage />} />
        <Route path="membership" element={<Membership />} />
        <Route
          path="membership-payment-checkout"
          element={<MemebrshipPaymentCheckoutPage />}
        />
        <Route path="merchant-profile" element={<MerchantProfilePage />} />
        <Route path="membership-upgrade" element={<MembershipUpgradePage />} />
        <Route path="membership-level" element={<MembershipLavelPage />} />
        <Route path="business-model" element={<BusinessModelPage />} />
        <Route path="business-create" element={<BusinessCreatePage />} />
        <Route
          path="business-contract-address"
          element={<BusinessContractAddressPage />}
        />
        <Route
          path="business-contract-list"
          element={<BusinessContractListPage />}
        />
        <Route path="business-day-info" element={<BusinessDayInfoPage />} />
        <Route path="personal-details" element={<PersonalDetailsPage />} />
        <Route path="brand-add" element={<BrandAddPage />} />
        <Route path="bank-info" element={<AddBankInfoPage />} />
        <Route
          path="my-shop/:shopId/unsettled-orders"
          element={<ShopUnsettledOrdersPage />}
        />
        <Route
          path="my-shop/:shopId/settled-orders"
          element={<ShopSettledOrdersPage />}
        />
        <Route
          path="my-shop/:orderId/settled-orders/details"
          element={<ShopSettledOrderDetailsPage />}
        />
        <Route
          path="my-shop/:shopId/demo-bank-info"
          element={<ShopRequestProductAddPage />}
        />
        <Route
          path="shops/:shopId/chats"
          element={<ShopChatPage />}
        />
        <Route
          path="myshop/:shopId/shop-product-request"
          element={<RequestProductAddPage />}
        />
        <Route
          path="shops/:shopId/campaign/:campaignId/assign-products"
          element={<CampaignAssignProductPage />}
        />
        <Route
          path="shops/:shopId/campaign/:campaignId/campaign-products"
          element={<CampaignProductPage />}
        />
        <Route
          path="shops/:shopId/campaign/:campaignId/details"
          element={<CampaignDetailsPage />}
        />
        <Route
          path="shops/:orderId/myshop-order-details"
          element={<MyShopOrderDetailsPage />}
        />
        {/* new route add */}
        <Route
          path="shops/:shopId/product/:slug/details"
          element={<ShopProductDetailsPage />}
        />
        <Route
          path="shops/:shopId/request/product/:slug/details"
          element={<ShopRequestProductDetailsPage />}
        />
        <Route
          path="shops/:shopId/request/product/:slug/edit"
          element={<ShopRequestProductEditPage />}
        />
        <Route
          path="shops/:shopId/product/cataloge/:slug/details"
          element={<ShopCatalogProductDetailsPage />}
        />
        <Route
          path="shops/:shopId/product/outofstock/:slug/details"
          element={<ShopOutOfStockProductDetailsPage />}
        />

        {/* new route edit */}

        <Route path="bank-info" element={<BankInfoPage />} />
        {!token ? (
          <>
            <Route path="*" element={<LandingPage />} />
            <Route
              path={`${process.env.PUBLIC_URL}/`}
              element={<LandingPage />}
            />
          </>
        ) : (
          <>
            <Route path="*" element={<NotFound />} />
            {adminServices?.flatMap((service, index) => {
              if (service?.sub?.length) {
                return [
                  ...(service?.sub?.map((sub, i) => {
                    const ServiceElemnt = sub?.element;
                    return (
                      isAllowedService(`${service.name} ${sub.name}`) &&
                      ServiceElemnt && (
                        <Route
                          key={i}
                          path={`${process.env.PUBLIC_URL}${service?.path}${sub?.path}`}
                          element={<ServiceElemnt />}
                        />
                      )
                    );
                  }) || []),
                ];
              } else {
                const ServiceElemnt = service?.element;
                return (
                  isAllowedService(service?.name) && (
                    <Route
                      key={index}
                      path={`${process.env.PUBLIC_URL}${service?.path}`}
                      element={<ServiceElemnt />}
                    />
                  )
                );
              }
            })}
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
};
export default MainRoutes;
